import React from 'react';
import InsightsMonthlySummary from './InsightsMonthlySummary';
import {Paper} from '@material-ui/core'
import { connect } from 'react-redux';
import BCLLoading from '../../../common/Loading/BCLLoading';
import { fetchMonthlySummaryData } from '../../../../dataFetchers/monthlySummaryDataFetcher';
import { getBECompatibleLocale, getBECompatibleFuelType } from '../../../../helpers/helper';
import { PAGE_EVENT_NAMES, INSIGHTS_PAGES} from '../../../../constants/common';
import { withLastLocation } from "react-router-last-location";
import { trackEvent } from '../../../../helpers/analyticsHelper';

class InsightsMonthlySummaryContainer extends React.Component{
    componentDidMount(){
        //call analytics function to save viewed event
        trackEvent(this.props.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            viewed: true,
            dashboardView: this.props.configs.data['fuelType'],
            shown: INSIGHTS_PAGES.MONTHLY_SUMMARY
        }, this.props);

        if(this.props.monthlySummaryData.monthlySummaryDataArray.length === 0){
            let options = {
                "date-format" : this.props.configData["date_format"],
                "locale" : getBECompatibleLocale(this.props.configData),
                "measurement-type" : getBECompatibleFuelType(this.props.configs.data['fuelType'])
            }
            this.props.fetchMonthlySummaryData(this.props.userId, options ,false);
        }
    }

    render(){
        const {monthlySummaryData} = this.props
        return(
        <Paper className="insights-ms-inner-container">
           {monthlySummaryData.monthlySummaryDataArray.length !== 0 ? <InsightsMonthlySummary/> : (!monthlySummaryData.apiFailed ? <BCLLoading/> : <div className="error-page"><div className="error-msg">{this.props.translationsData["MONTHLY_SUMMARY.DATA_NOT_AVAILABLE"]}</div></div>)}
        </Paper>
        )
    }
}

const mapStateToProps = state => {
    return{
        monthlySummaryData : state.monthlySummaryData,
        userId: state.userIdentityDetails.userId,
        configData : state.configs.data,
        translationsData : state.translationsData.data,
        queryParams: state.queryParams,
        configs: state.configs
    }
}

const mapDispatchToProps = dispatch => {
    return{
        fetchMonthlySummaryData : (uuid, options, isPrevious) => dispatch(fetchMonthlySummaryData(uuid, options, isPrevious))
    }
}

export default withLastLocation(connect(mapStateToProps, mapDispatchToProps)(InsightsMonthlySummaryContainer));

